import { Tag } from 'lucide-react';
import { UserTagBadge } from '@/components/user/UserTagBadge';

interface PerfilTagsTabProps {
    groupedTags: Record<string, any[]>;
    userName: string;
}

export function PerfilTagsTab({ groupedTags, userName }: PerfilTagsTabProps) {
    return (
        <div className="space-y-8 max-w-4xl mx-auto">
            <div className="bg-neutral-900/30 border border-white/5 rounded-2xl p-6 md:p-8">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 bg-orange-500/10 rounded-lg">
                        <Tag className="text-orange-500" size={24} />
                    </div>
                    <div>
                        <h2 className="text-xl font-bold text-white">Coleção de Tags</h2>
                        <p className="text-white/40 text-sm">Todas as tags conquistadas por {userName}</p>
                    </div>
                </div>

                <div className="space-y-8">
                    {Object.entries(groupedTags).map(([pacote, tags]: [string, any]) => (
                        <div key={pacote} className="space-y-4">
                            <div className="flex items-center gap-4">
                                <h3 className="text-sm font-bold text-white/40 uppercase tracking-widest whitespace-nowrap">{pacote}</h3>
                                <div className="h-px w-full bg-white/5" />
                            </div>
                            <div className="flex flex-wrap gap-3">
                                {tags.map((tag: any) => (
                                    <UserTagBadge key={tag.tag_id} tag={tag} size="md" />
                                ))}
                            </div>
                        </div>
                    ))}

                    {Object.keys(groupedTags).length === 0 && (
                        <div className="py-20 text-center">
                            <Tag size={48} className="mx-auto text-white/10 mb-4" />
                            <p className="text-white/40">Este usuário ainda não possui tags.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
